module.exports = __webpack_public_path__ + "static/media/round-account-circle-24-px.50b90609.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-account-circle-24-px.svg
// module id = 768
// module chunks = 0